<template>
  <div class="scroll">
    <table class="table">
      <thead class="thead">
        <tr class="column-main">
          <th class="column-main-title" v-for="column of columns" :key="column">
            {{ column.label }}
            <img
              :class="{
                'img-down': true,
                'img-rotation': changeSort
              }"
              src="@/assets/icons/Down.svg"
              v-if="
                column.value === 'reservedTime' &&
                $route.name === 'APIReservations'
              "
              @click="$emit('sortReservedTime')"
            />
          </th>
          <th
            v-if="
              isDeliveryHistory ||
              (isUsers && user?.role.permissions.user.delete) ||
              isReservations
            "
            class="column-main-img"
          ></th>
        </tr>
      </thead>
      <tbody class="tbody">
        <tr class="column-content" v-for="(i, idx) of data" :key="i.id">
          <td
            class="column-content-title"
            v-for="column of columns"
            :key="column"
            @click="selectRow(i, column.value)"
          >
            <img
              class="img-expired"
              src="@/assets/icons/Red.svg"
              v-if="
                column.value === 'deliveryIds' &&
                $route.name === 'Reservations' &&
                i.deliveryStatus === 'expired'
              "
            />
            <img
              :src="
                require(`@/assets/icons/${getDeliveryStatus(
                  i[column.value]
                )}.svg`)
              "
              alt="status"
              v-if="column.value === 'deliveryStatus'"
            />
            <span>{{ getColumnValue(i, column) }}</span>
            <div
              :class="{
                'column-content-img': !isChooseDelivery,
                tootip: isChooseDelivery || isAPIReservations
              }"
              v-if="column.value === 'assign'"
            >
              <img
                v-if="(isChooseDelivery && !i.req_ph_ssn) || isAPIReservations"
                class="img"
                src="@/assets/icons/Add.svg"
                alt="Add"
                @click="$emit('assignDeliveryTable', i[this.selectedField])"
              />
              <img
                v-if="isChooseDelivery && i.req_ph_ssn"
                :class="{ img: true, 'img-plus': i.req_ph_ssn }"
                src="@/assets/icons/Plus.svg"
                alt="Add"
              />
              <span
                v-if="(isChooseDelivery && !i.req_ph_ssn) || isAPIReservations"
                class="tooltiptext"
              >
                {{ $t('chooseThisDelivery') }}
              </span>
              <span
                v-if="isChooseDelivery && i.req_ph_ssn"
                :class="{
                  tooltiptext: true,
                  'tooltiptext-long': isChooseDelivery && i.req_ph_ssn
                }"
              >
                {{ $t('onlyShelves') }}
              </span>
            </div>
            <img
              v-if="
                column.value === 'lockerIdOrShelf' &&
                !i.lockerId &&
                pharmacy.shelves &&
                isReservations
              "
              class="img-editShelf"
              src="@/assets/icons/EditGreen.svg"
            />
          </td>
          <td
            class="column-content-img"
            v-if="isReservations"
            @click="$emit('openQRCode', i[this.selectedField])"
          >
            <img class="img" src="@/assets/icons/Qr-code.svg" alt="Qr-code" />
          </td>
          <td
            class="column-content-img"
            v-if="isReservations"
            @click="$emit('addDescription', i[this.selectedField])"
            :data-testid="'editDescription' + idx"
          >
            <img class="img" src="@/assets/icons/Edit.svg" alt="Edit" />
          </td>
          <td
            class="column-content-img"
            v-if="isDeliveryHistory || isAlarms"
            @click="selectField(i)"
            :data-testid="'editDescriptionDeliveryHistory' + idx"
          >
            <img class="img" src="@/assets/icons/Edit.svg" alt="Edit" />
          </td>
          <td
            :class="{
              'column-content-img':
                !i.lockerId || i.deliveryStatus === 'delivered',
              'column-content-img-displayNone':
                i.lockerId || i.deliveryStatus !== 'delivered'
            }"
            v-if="isReservations"
            @click="$emit('resendSMSRequest', i[this.selectedField])"
            :data-testid="'resendSMS' + idx"
          >
            <img
              class="img imgSMS"
              src="@/assets/icons/SMS.svg"
              alt="Resend SMS"
            />
          </td>
          <td
            v-if="isAPIReservations"
            :class="{
              'column-content-img': true,
              'column-content-img-quickRes': i.req_ph_ssn && isAPIReservations
            }"
            @click="
              !i.req_ph_ssn && isAPIReservations
                ? $emit('quickReservation', i[this.selectedField])
                : ''
            "
          >
            <Button
              class="quickReservation__button"
              variant="bordered"
              :title="$t('quickReservation')"
            />
          </td>
          <td
            class="column-content-img"
            v-if="(isReservations && !i.lockerId) || isAPIReservations"
            @click="$emit('deleteReservationTable', i[this.selectedField])"
            :data-testid="'deleteReservation' + idx"
          >
            <img
              class="img imgDelete"
              src="@/assets/icons/Delete.svg"
              alt="Delete"
            />
          </td>
          <td
            :class="{
              'column-content-img':
                (isReservations && !i.lockerId) || isAPIReservations,
              'column-content-img-displayNone': i.lockerId && !isAPIReservations
            }"
            v-if="isReservations || isAPIReservations"
            @click="$emit('pickedUpReservation', i[this.selectedField])"
            :data-testid="'pickedUpReservation' + idx"
          >
            <img
              class="img imgReservation"
              src="@/assets/icons/PickedUpReservation.svg"
              alt="Picked Up Reservation"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div class="observer" ref="observer"></div>
  </div>
</template>

<script lang="ts">
import { PharmacyAccesses, UserProfile } from '@/store/modules/account/types';
import {
  AlarmsData,
  AlarmSensor,
  APIDataReservations,
  Check,
  DataReservations,
  Delivery,
  Sensor
} from '@/store/modules/pharmacy/types';
import { DataLoginInformation } from '@/store/modules/users/types';
import { Column } from '@/types';
import moment from 'moment';
import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';

@Options({
  name: 'Table',
  props: ['data', 'columns', 'selectedField', 'changeSort'],
  computed: {
    ...mapState('account', ['user']),
    ...mapState('pharmacy', ['pharmacy']),
    isDeliveryHistory() {
      return this.$route.name === 'DeliveryHistory';
    },
    isUsers() {
      return this.$route.name === 'Users';
    },
    isReservations() {
      return this.$route.name === 'Reservations';
    },
    isChooseDelivery() {
      return this.$route.name === 'Lockers';
    },
    isAlarms() {
      return this.$route.name === 'Alarms';
    },
    isAPIReservations() {
      return this.$route.name === 'APIReservations';
    }
  },
  methods: {
    selectRow(i: Record<string, unknown>, column: string) {
      if (
        (column === 'deliveryId' || column === 'deliveryIds') &&
        !this.isAPIReservations
      ) {
        this.$emit('openQRCode', i[this.selectedField]);
      } else if (
        this.isReservations &&
        column === 'lockerIdOrShelf' &&
        !i.lockerId &&
        this.pharmacy.shelves
      ) {
        this.$emit('editShelf', i[this.selectedField]);
      } else if (
        (this.isAPIReservations ||
          this.isReservations ||
          this.isDeliveryHistory ||
          this.isUsers) &&
        column !== 'assign'
      ) {
        this.$emit('goToItem', i[this.selectedField] || i.id);
      }
    },
    selectField(i: Record<string, unknown>) {
      return this.isAlarms
        ? this.$emit('addAlarmComment', i)
        : this.$emit('addDescription', i[this.selectedField]);
    },
    getUserName(item: Record<string, unknown>) {
      return `${item.firstName} ${item.lastName}`;
    },
    getIds(item: APIDataReservations | DataReservations) {
      if (!item?.additionalDeliveryIds[0] && !item?.additionalDeliveryIds[1]) {
        return item.deliveryId;
      } else if (item?.additionalDeliveryIds[1] !== '') {
        return item.deliveryId + ', ' + item.additionalDeliveryIds.join(', ');
      } else if (item?.additionalDeliveryIds[1] === '') {
        return item.deliveryId + ', ' + item.additionalDeliveryIds.join('');
      }
    },
    dateTime(value: number) {
      return value ? moment(value).format('DD.MM.YYYY HH:mm') : '';
    },
    getDeliveryStatus(item: string) {
      const colors: Record<string, string> = {
        reserved: 'Orange',
        delivered: 'Blue',
        pickup: 'Green',
        expired: 'Gray',
        cancelled: 'Red',
        removed: 'Red',
        deleted: 'Red',
        destroyed: 'Red',
        auto_destroyed: 'Red',
        lost: 'Red'
      };

      return colors[item] ?? 'Gray';
    },
    getDeliveryLabel(item: string) {
      const labels: Record<string, unknown> = {
        reserved: this.$t('reservedTable'),
        delivered: this.$t('deliveredTable'),
        pickup: this.$t('pickedUpTable'),
        expired: this.$t('expiredTable'),
        cancelled: this.$t('cancelledTable'),
        removed: this.$t('removedTable'),
        deleted: this.$t('deletedTable'),
        destroyed: this.$t('destroyedTable'),
        auto_destroyed: this.$t('destroyedTable'),
        lost: this.$t('lostTable')
      };

      return labels[item];
    },
    getRoleLabel(item: string, data: UserProfile) {
      const labels: Record<string, unknown> = {
        main_user: this.$t('mainUser'),
        user: this.$t('user')
      };

      if (data.pharmacyAccesses) {
        const id = data.pharmacyId;
        const pharmacyId = localStorage.getItem('id');

        const roleNameForPharmacy: PharmacyAccesses | undefined =
          data.pharmacyAccesses.find(
            (itemData: PharmacyAccesses) => itemData.pharmacyId === id
          );

        const roleNameForPharmacyId: PharmacyAccesses | undefined =
          data.pharmacyAccesses.find(
            (itemData: PharmacyAccesses) => itemData.pharmacyId === pharmacyId
          );

        if (roleNameForPharmacyId) {
          return labels[roleNameForPharmacyId?.roleName];
        } else if (roleNameForPharmacy) {
          return labels[roleNameForPharmacy?.roleName];
        } else {
          return labels[item];
        }
      } else {
        return labels[item];
      }
    },
    getDuration(item: AlarmsData | AlarmSensor) {
      let startDate: number | undefined;
      const endDate = item.alarmEndTimestamp;

      if ('alarmStartTimestamp' in item) {
        startDate = item.alarmStartTimestamp;
      } else {
        startDate = item.timestamp;
      }

      if (endDate) {
        const diffTime = Math.abs(endDate - startDate);
        const diffH = Math.ceil(diffTime / (1000 * 60 * 60) - 1);
        const diffMin = Math.ceil(diffTime / (1000 * 60));

        if (!startDate || !endDate) return '';
        if (diffTime === 0) return 0;

        if (diffH === 1) {
          return `${diffH} ${this.$t('hour')}`;
        } else if (diffH === 0) {
          return `${diffMin} ${this.$t('min')}`;
        } else {
          return `${diffH} ${this.$t('hours')}`;
        }
      }
    },
    rounded(averageTemp: number) {
      return +averageTemp.toFixed(2);
    },
    getAverageTemp(item: AlarmsData) {
      let averageTemp;

      if (item.alarmMax && item.alarmMin) {
        averageTemp = (item.alarmMax + item.alarmMin) / 2;
      } else if (item.alarmMax && !item.alarmMin) {
        averageTemp = item.alarmMax / 2;
      } else if (!item.alarmMax && item.alarmMin) {
        averageTemp = item.alarmMin / 2;
      }

      if (!averageTemp) {
        return '';
      }

      this.rounded(averageTemp);

      return `${this.rounded(averageTemp)}`;
    },
    getLockerId(item: Array<string>) {
      return item?.join(', ');
    },
    getLockerIdOrShelf(data: DataReservations) {
      if (data?.shelf) {
        return data?.shelf
          .map((item: string) =>
            item === 'cooling' ? this.$t('cooling') : item.toUpperCase()
          )
          .join(', ');
      } else {
        return this.getLockerId(data?.lockerId);
      }
    },
    getType(item: string) {
      const type: Record<string, unknown> = {
        fridge: this.$t('fridge'),
        large: this.$t('large'),
        medium: this.$t('medium'),
        small: this.$t('small')
      };

      return type[item];
    },
    getMonth(item: string) {
      const months: Record<string, unknown> = {
        0: this.$t('january'),
        1: this.$t('february'),
        2: this.$t('march'),
        3: this.$t('april'),
        4: this.$t('may'),
        5: this.$t('june'),
        6: this.$t('july'),
        7: this.$t('august'),
        8: this.$t('september'),
        9: this.$t('october'),
        10: this.$t('november'),
        11: this.$t('december')
      };

      return months[item];
    },
    getInfoType(item: DataLoginInformation) {
      return `${this.$t('log')} ${item.info}`;
    },
    getTime(data: Record<string, unknown>, column: Column) {
      return data[column.value] ? this.dateTime(data[column.value]) : '';
    },
    getAssignedTime(data: DataReservations) {
      return data?.assignedTime ? this.dateTime(data.assignedTime) : '';
    },
    getComment(comment: Check) {
      const checkTime = moment(comment.checkTime).format('DD.MM.YYYY HH:mm');
      const checkName = comment.checkName;
      const commentText =
        comment.alarmInfo.length > 30
          ? `${comment.alarmInfo.slice(0, 30)}...`
          : comment.alarmInfo;

      return `${commentText} (${checkName} ${checkTime})`;
    },
    getAlarmComments(data: AlarmsData) {
      if (data.check) {
        const alarmInfoData = data.check.slice(1).map(this.getComment);

        return alarmInfoData.join('; ');
      }
    },
    getDescriptionText(data: Delivery) {
      const descriptionTextData = data.descriptionText;

      return descriptionTextData?.length > 30
        ? `${descriptionTextData.slice(0, 30)}...`
        : descriptionTextData;
    },
    getAlarmType(data: AlarmsData) {
      const type: Record<string, unknown> = {
        ok: this.$t('alarmOk'),
        door_open: this.$t('alarmDoorOpen'),
        door_closed: this.$t('alarmDoorClosed'),
        temp_high: this.$t('alarmTempHigh'),
        temp_low: this.$t('alarmTempLow'),
        other: this.$t('alarmOther'),
        missing: this.$t('alarmMissing'),
        connection_lost: this.$t('connection_lost')
      };

      return type[data.alarmType];
    },
    getSensor(data: AlarmsData) {
      if (data.alarmType === 'temp_high' || data.alarmType === 'temp_low') {
        if (data.lockerId !== '99-99') {
          return `${this.$t('fridge')} ${data.lockerId}`;
        } else {
          return `${this.$t('roomTemp')}`;
        }
      } else if (data.lockerId) {
        return `${data.lockerId}`;
      }
    },
    getDrugAndNarcotics(data: boolean) {
      return data ? `${this.$t('yes')}` : `${this.$t('noTable')}`;
    },
    getReservedUserName(data: DataReservations) {
      return data.reservedUserId === 'API' ? 'API' : data.reservedUserName;
    },
    getDeliveryTime(data: DataReservations) {
      if (!data.lockerId) {
        if (data.deliveryTime) {
          return this.dateTime(data.deliveryTime);
        } else {
          return this.dateTime(data.reservedTime);
        }
      }
      return this.dateTime(data.deliveryTime);
    },
    pickedUpAndDestroyed(data: Record<string, unknown>) {
      if (data.deliveryStatus === 'cancelled') {
        return this.dateTime(data.cancelTime);
      }

      if (data.deliveryStatus === 'lost') {
        return this.dateTime(data.lostTime);
      }

      if (data.pickupTime) {
        return this.dateTime(data.pickupTime);
      }

      return this.dateTime(data.destroyTime);
    },
    getSensorName(data: AlarmSensor) {
      return (
        this.pharmacy.sensors.find((sensor: Sensor) => sensor.id === data.id)
          ?.name || ''
      );
    },
    // eslint-disable-next-line
    getColumnValue(data: string, column: Record<string, any>) {
      switch (column.value) {
        case 'alarmStartTimestamp':
        case 'alarmEndTimestamp':
        case 'timestamp':
          return this.dateTime(data[column.value]);
        case 'expiredTime':
        case 'reservedTime':
        case 'pickupTime':
        case 'destroyTime':
          return this.getTime(data, column);
        case 'pickedUpAndDestroyed':
          return this.pickedUpAndDestroyed(data);
        case 'loginInfoUserName':
        case 'nameUser':
          return this.getUserName(data, column);
        case 'deliveryStatus':
          return this.getDeliveryLabel(data[column.value]);
        case 'lockerId':
          return this.getLockerId(data[column.value]);
        case 'lockerIdOrShelf':
          return this.getLockerIdOrShelf(data);
        case 'deliveryIds':
          return this.getIds(data);
        case 'duration':
          return this.getDuration(data, column);
        case 'averageTemp':
          return this.getAverageTemp(data, column);
        case 'type':
          return this.getType(data[column.value]);
        case 'month':
          return this.getMonth(data[column.value]);
        case 'infoType':
          return this.getInfoType(data, column);
        case 'role':
          return this.getRoleLabel(data[column.value], data);
        case 'alarmComment':
          return this.getAlarmComments(data, column);
        case 'descriptionText':
          return this.getDescriptionText(data, column);
        case 'alarmType':
          return this.getAlarmType(data);
        case 'sensor':
          return this.getSensor(data);
        case 'is_drug':
          return this.getDrugAndNarcotics(data[column.value]);
        case 'req_ph_ssn':
          return this.getDrugAndNarcotics(data[column.value]);
        case 'reservedUserName':
          return this.getReservedUserName(data);
        case 'deliveryTime':
          return this.getDeliveryTime(data);
        case 'assignedTime':
          return this.getAssignedTime(data);
        case 'name':
          return this.getSensorName(data);
        default:
          return data[column.value];
      }
    }
  },
  mounted() {
    const options = {
      rootMargin: '0px',
      threshold: 1.0
    };

    const callback = (entries: IntersectionObserverEntry[]) => {
      const lastElement = this.data[this.data.length - 1];
      if (entries[0].isIntersecting && lastElement) {
        this.$emit('loadMore', lastElement.id || lastElement);
      }
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(this.$refs.observer);
  }
})
export default class Table extends Vue {}
</script>

<style scoped lang="scss">
.scroll {
  overflow: auto;
  max-height: 884px;
  min-height: 310px;
  height: 100%;
  .table {
    width: 100%;
    border-collapse: collapse;
    .thead {
      .column-main {
        text-align: left;
        .column-main-title {
          position: sticky;
          top: 0;
          font-family: 'Ubuntu-Medium';
          font-size: $tenSize;
          line-height: $thirteenSize;
          background: $white;
          color: $columnMainTitle;
          padding: 20px 10px;
          letter-spacing: 2px;
          z-index: 1;
          .img-down {
            cursor: pointer;
          }
          .img-rotation {
            transform: rotate(180deg);
          }
        }
        .column-main-img {
          position: sticky;
          top: 0;
          width: 25px;
          background: $white;
        }
      }
    }
    .tbody {
      overflow-y: scroll;
      .column-content {
        border-top: 1px solid $borderTopLine;
        height: 46px;
        &:hover {
          background-color: $light-grey;
          cursor: pointer;
        }
        &:hover .column-content-title {
          background-color: $light-grey;
        }
        &:hover .column-content-title span {
          background-color: $light-grey;
        }
        &:hover .column-content-title .column-content-pickedUp {
          background-color: $light-grey;
        }
        &:hover .column-content-img {
          background-color: $light-grey;
        }
        &:hover .column-content-title .img-editShelf {
          height: 18px;
          width: 18px;
          opacity: 1;
          background-color: $light-grey;
        }
        &:hover .tootip {
          background-color: $light-grey;
        }
        &:hover .tootip .img {
          &.img-plus {
            height: 14px;
            width: 14px;
            cursor: default;
          }
          opacity: 1;
          background-color: $light-grey;
        }
        &:hover .column-content-img .img {
          height: 18px;
          width: 18px;
          opacity: 1;
          background-color: $light-grey;
        }
        &:hover .column-content-img .imgReservation {
          height: 18px;
          width: 18px;
          opacity: 1;
          filter: invert(58%) sepia(7%) saturate(2247%) hue-rotate(111deg)
            brightness(89%) contrast(99%);
          background-color: rgb(225 82 64 / 0%);
        }
        &:hover .column-content-img .imgDelete {
          height: 18px;
          width: 18px;
          opacity: 1;
          filter: invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg)
            brightness(104%) contrast(97%);
          background-color: rgb(225 82 64 / 0%);
        }
        &:hover .column-content-img .imgSMS {
          height: 18px;
          width: 18px;
          opacity: 1;
        }
        &:hover .column-content-img .quickReservation__button {
          opacity: 1;
        }
        &:hover .column-content-img-displayNone {
          background-color: $light-grey;
        }
        .column-content-title {
          padding: 13px 10px;
          font-size: $fourteenSize;
          line-height: 20px;
          vertical-align: middle;
          color: $columnContentTitle;
          .column-content-pickedUp {
            display: flex;
            align-items: center;
            .pickedUp-button {
              display: flex;
              align-items: center;
              justify-content: center;
              column-gap: 5px;
            }
          }
          .img-expired {
            padding-right: 5px;
          }
          .img-editShelf {
            height: 18px;
            width: 18px;
            opacity: 0;
            margin-left: 8px;
          }
        }
        .column-content-img {
          vertical-align: middle;
          padding: 5px;
          &.column-content-img-quickRes {
            opacity: 0;
          }
          .img {
            height: 18px;
            width: 18px;
            opacity: 0;
            margin: 0 5px;
          }
          .quickReservation__button {
            width: 150px;
            height: 30px;
            opacity: 0;
          }
        }
        .column-content-img-displayNone {
          display: none;
        }
        .tootip {
          position: relative;
          display: inline-block;
          .img {
            opacity: 0;
          }
          .tooltiptext {
            visibility: hidden;
            width: 120px;
            font-size: $elevenSize;
            line-height: $elevenSize;
            background: $label !important;
            color: $white;
            text-align: center;
            border-radius: 6px;
            padding: 5px 0;
            position: absolute;
            z-index: 1;
            top: -35%;
            left: 50%;
            transform: translate(-50%, -100%);
            opacity: 0;
            transition: opacity 0.3s;
            &::after {
              content: '';
              position: absolute;
              top: 97%;
              left: 50%;
              margin-left: -5px;
              border-width: 5px;
              border-style: solid;
              border-color: $label transparent transparent transparent;
            }
            &.tooltiptext-long {
              width: 145px;
              padding: 5px;
            }
          }

          &:hover .tooltiptext {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
    .observer {
      height: 10px;
      margin-top: 100px;
      background: transparent;
    }
  }
}

.table > :not(:first-child) {
  border-top: none;
}
</style>
